// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shipping-module_no_content_Rt3cN {
}

.Shipping-module_shipping_info_group_dkFDh {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.Shipping-module_tracking_and_date_group_HYTaD {
  width: 100%;
  padding-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.Shipping-module_input_group_o5APe {
  display: inline-flex;
  align-items: center;
}

.Shipping-module_tracking_group_lZH5H {
  flex: 1 1 30%;
}

.Shipping-module_date_group_oRiwj {
  flex: 1 1 26%;
}

.Shipping-module_input_label_sB_fg {
}

.Shipping-module_cost_group_XlCpf {
  display: flex;
  align-items: baseline;
  text-align: right;
}

.Shipping-module_cost_group_XlCpf > span {
  margin-right: auto;
}

.Shipping-module_shipping_speed_label_trytd {
  background-color: var(--status_new);
  padding: 4px;
}

.Shipping-module_shipping_speed_two_day_vHLfO {
  background-color: var(--status_transaction_created);
}

.Shipping-module_shipping_speed_next_day_rddcl {
  background-color: var(--status_approved);
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Shipping/Shipping.module.css"],"names":[],"mappings":"AAAA;AAEA;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EAEE,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EAEE,mDAAmD;AACrD;;AAEA;EAEE,wCAAwC;AAC1C","sourcesContent":[".no_content {\n  composes: no_content from 'Styles/styles.module.css';\n}\n\n.shipping_info_group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.tracking_and_date_group {\n  width: 100%;\n  padding-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.input_group {\n  display: inline-flex;\n  align-items: center;\n}\n\n.tracking_group {\n  composes: input_group;\n  flex: 1 1 30%;\n}\n\n.date_group {\n  composes: input_group;\n  flex: 1 1 26%;\n}\n\n.input_label {\n  composes: input_label from 'Styles/styles.module.css';\n}\n\n.cost_group {\n  display: flex;\n  align-items: baseline;\n  text-align: right;\n}\n\n.cost_group > span {\n  margin-right: auto;\n}\n\n.shipping_speed_label {\n  composes: status_tag from 'Styles/styles.module.css';\n  background-color: var(--status_new);\n  padding: 4px;\n}\n\n.shipping_speed_two_day {\n  composes: shipping_speed_label;\n  background-color: var(--status_transaction_created);\n}\n\n.shipping_speed_next_day {\n  composes: shipping_speed_label;\n  background-color: var(--status_approved);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no_content": `Shipping-module_no_content_Rt3cN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["no_content"]}`,
	"shipping_info_group": `Shipping-module_shipping_info_group_dkFDh`,
	"tracking_and_date_group": `Shipping-module_tracking_and_date_group_HYTaD`,
	"input_group": `Shipping-module_input_group_o5APe`,
	"tracking_group": `Shipping-module_tracking_group_lZH5H Shipping-module_input_group_o5APe`,
	"date_group": `Shipping-module_date_group_oRiwj Shipping-module_input_group_o5APe`,
	"input_label": `Shipping-module_input_label_sB_fg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["input_label"]}`,
	"cost_group": `Shipping-module_cost_group_XlCpf`,
	"shipping_speed_label": `Shipping-module_shipping_speed_label_trytd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["status_tag"]}`,
	"shipping_speed_two_day": `Shipping-module_shipping_speed_two_day_vHLfO Shipping-module_shipping_speed_label_trytd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["status_tag"]}`,
	"shipping_speed_next_day": `Shipping-module_shipping_speed_next_day_rddcl Shipping-module_shipping_speed_label_trytd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["status_tag"]}`
};
export default ___CSS_LOADER_EXPORT___;
